import { Component, type ErrorInfo, type ReactNode } from 'react';
import { RotateCcw, TriangleAlert } from 'lucide-react';
import { Button, Card, EmptyState } from '@eombor/ui';
import { t } from '../i18n/index.js';

interface Props {
  children: ReactNode;
  /**
   * Shu qiymat o'zgarganda chegara O'ZINI tiklaydi.
   *
   * Odatda joriy manzil beriladi: yiqilgan sahifadan boshqasiga o'tilsa,
   * eski xato ekranda qolib ketmasligi kerak. Busiz odam menyudan
   * boshqa bo'limni tanlaydi-yu, ekranda o'sha xato turaveradi.
   */
  resetKey?: string;
}

interface State {
  error: Error | null;
}

/**
 * Bitta sahifa yiqilsa BUTUN ilova o'chib qolmasin.
 *
 * React da render paytidagi ushlanmagan xato butun daraxtni yechib
 * tashlaydi — natijada oq ekran qoladi va odam nima bo'lganini ham,
 * qayerga borishni ham bilmaydi. Chegara faqat o'z ichidagini yo'qotadi:
 * qobiq, navigatsiya va menyu joyida qoladi, ya'ni boshqa bo'limga
 * o'tish mumkin.
 *
 * Sinf komponenti — ataylab: `componentDidCatch` ning funksiyali muqobili
 * React da bugungacha yo'q.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    /* Konsolga CHIQARILADI: xato yutib yuborilsa, uni faqat foydalanuvchi
       ko'radi va dasturchi hech qachon bilmaydi. */
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  override componentDidUpdate(previous: Props): void {
    if (this.state.error !== null && previous.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  override render(): ReactNode {
    if (this.state.error === null) return this.props.children;

    return (
      <Card>
        <EmptyState
          icon={<TriangleAlert size={20} aria-hidden />}
          title={t('boundary.title')}
          /* Stek va xato matni EKRANGA chiqmaydi — ular odamga hech narsa
             bermaydi. Tafsilot konsolda qoladi. */
          description={t('boundary.hint')}
          action={
            <Button variant="secondary" onClick={() => this.setState({ error: null })}>
              <RotateCcw size={16} aria-hidden />
              {t('boundary.retry')}
            </Button>
          }
        />
      </Card>
    );
  }
}
